import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { sidebarItems } from "../../constants";
import { getBrandsList, getProjectList } from "../../services/userService";
import Utils from "../../utility";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const [brandsWithProjects, setBrandsWithProjects] = useState([]);

  const fetchBrandsAndProjects = useCallback(async () => {
    const [error, response] = await Utils.parseResponse(
      getBrandsList({ page: 1, limit: 50 })
    );
    if (error || !response) return;

    const brands = response?.responseData || [];
    const results = await Promise.all(
      brands.map(async (brand) => {
        const [projErr, projRes] = await Utils.parseResponse(
          getProjectList(brand.id, 1, 3)
        );
        return {
          id: brand.id,
          brandName: brand.brandName,
          logo: brand.theme?.logo,
          projects:
            !projErr && projRes ? (projRes?.responseData || []).slice(0, 3) : []
        };
      })
    );
    setBrandsWithProjects(results.filter((b) => b.projects.length > 0));
  }, []);

  useEffect(() => {
    fetchBrandsAndProjects();
  }, [fetchBrandsAndProjects]);

  const handleSupportPage = () => {
    window.location.href =
      "mailto:alving@adperfect.ai?subject=Support Request&body=Hi AdPerfect Team,%0D%0A%0D%0AI need help with:%0D%0A%0D%0A";
  };

  return (
    <div
      className="relative flex h-screen w-20per flex-col overflow-y-auto bg-white pl-[20px]"
      style={{ boxShadow: "4px 0 12px rgba(0, 0, 0, 0.06)" }}
    >
      <img
        src="/images/adperfect-logo-dark.svg"
        className="mt-6per px-[20px]"
        style={{ width: 200, maxWidth: "100%" }}
        alt="Dark logo"
      />
      <div className="mt-[28px]">
        {sidebarItems.map((item, index) => {
          return (
            <div
              className={`m-2 ml-15per flex h-11 cursor-pointer items-center rounded-xl py-7 pl-4`}
              key={index}
              onClick={() => {
                item.path === "/support"
                  ? handleSupportPage()
                  : navigate(`${item.path}`);
              }}
            >
              <div
                className={`flex size-7.5 items-center justify-start rounded-md p-2 ${currentPath.includes(item.value) ? "mr-2 bg-green-12" : "mr-2"}`}
              >
                <img
                  src={
                    currentPath.includes(item.value)
                      ? item.activeIcon
                      : item.inactiveicon
                  }
                  alt="ico"
                  className="size-4"
                />
              </div>
              <div
                className={`font-InterBold text-ft14-20 ${currentPath.includes(item.value) ? "text-grey-12" : "text-grey-14"}`}
              >
                {item.name}
              </div>
            </div>
          );
        })}
      </div>

      {/* Recent Projects Section */}
      {brandsWithProjects.length > 0 && (
        <div className="ml-15per mt-4 py-7  pl-4">
          <div className="mb-2 flex items-center">
            <div className="mr-2 flex size-7.5 items-center justify-start rounded-md p-2">
              <img
                src="/images/person-icon-inactive.svg"
                alt="Recent Projects"
                className="size-4"
              />
            </div>
            <span className="font-InterBold text-ft14-20 text-grey-14">
              Recent Projects
            </span>
          </div>

          {brandsWithProjects.map((brand) => (
            <div key={brand.id} className="mb-3 py-7">
              {/* Brand row */}
              <div
                className="flex cursor-pointer items-center"
                style={{ paddingLeft: 45 }}
                onClick={() => navigate(`/dashboard/brand/details/${brand.id}`)}
              >
                {brand.logo ? (
                  <img
                    src={brand.logo}
                    alt={brand.brandName}
                    className="mr-2 size-5 rounded-full object-cover"
                  />
                ) : (
                  <div className="mr-2 flex size-5 items-center justify-center rounded-full bg-grey-14 p-2 font-InterBold text-[10px] text-white">
                    {brand.brandName?.charAt(0)?.toUpperCase()}
                  </div>
                )}
                <span className="font-InterSemibold text-ft14-20 text-grey-12">
                  {Utils.shortenString(brand.brandName, 18)}
                </span>
              </div>

              {/* Project list */}
              {brand.projects.map((project) => (
                <div
                  key={project.id}
                  className="cursor-pointer py-7 font-InterRegular text-ft12-16 text-grey-14 hover:text-green-12"
                  style={{ paddingLeft: 72 }}
                  onClick={() =>
                    navigate(
                      `/dashboard/brand/details/project/finalReview/${project.id}`
                    )
                  }
                >
                  {Utils.shortenString(project.projectName, 22)}
                </div>
              ))}

              {/* See all projects */}
              <div
                className="cursor-pointer py-7 font-InterRegular text-ft12-16 text-grey-14 hover:text-green-12"
                style={{ paddingLeft: 72 }}
                onClick={() => navigate(`/ad-library?brandId=${brand.id}`)}
              >
                See all projects
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Sidebar;
